<template>
  <div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item label="用户账号" prop="userName">
            <el-input v-model="queryForm.userName" placeholder="请输入用户账号"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="用户类型" prop="userType">
            <el-select v-model="queryForm.userType" clearable placeholder="请选择用户类型">
              <el-option
                  v-for="item in allUserType"
                  :key="item.userTypeNum"
                  :label="item.userTypeName"
                  :value="item.userTypeName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="状态" prop="status">
            <el-select v-model="queryForm.status" clearable placeholder="请选择审核状态">
              <el-option
                  v-for="item in reviewStatus"
                  :key="item.statusName"
                  :label="item.statusName"
                  :value="item.statusName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="审核人" prop="reviewUserName">
            <el-input v-model="queryForm.reviewUserName" placeholder="请输入审核人"/>
          </el-form-item>
        </el-col>
        <!--<el-col :span="5">
          <el-form-item label="审核时间" prop="status">
            <el-select v-model="queryForm.status" clearable placeholder="请选择时间类型">
              <el-option
                  v-for="item in reviewStatus"
                  :key="item.statusName"
                  :label="item.statusName"
                  :value="item.statusName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>-->
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="时间段" prop="timeRange">
            <el-date-picker
                v-model="queryForm.timeRange"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="4">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
            <el-button type="primary" size="small" plain
                       @click="exportInvistMoneyData" icon="el-icon-refresh">
              导出</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

    <el-card>
      <el-button type="success" size="small" style="margin: 0 0 10px 20px"
                 @click="handleReviewAdd('批量通过')">批量通过</el-button>
      <el-button type="success" size="small" style="margin: 0 0 10px 20px"
                 @click="handleReviewProBatch('批量审核')">批量审核中</el-button>
      <el-table :data="tableData" border default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :max-height="tableHeight"
                style="width: 100%;margin-bottom: 20px;"
                @selection-change="handleSelectionChange">
        <el-table-column label="全选" width="50" type="selection"/>
        <el-table-column prop="dateTime" label="时间" />
        <el-table-column prop="serialNumber" label="交易流水号" />
        <el-table-column prop="userName" label="用户账号" />
        <el-table-column prop="userType" label="用户类型" />
        <el-table-column prop="ownerWebBusinessUser" label="分站/业务员" />
        <el-table-column prop="money" label="金额" />
        <el-table-column prop="transferMoneyImageUrl" label="充值截图" width="160">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px;margin: 1%;"
                      :src="scope.row.transferMoneyImageUrl"
                      :preview-src-list="new Array(scope.row.transferMoneyImageUrl)"
                      lazy>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="receiveBackInfos" label="收款信息" width="250">
          <template slot-scope="scope">
              <el-row :gutter="5">
                <el-col :span="8">银行：</el-col>
                <el-col :span="16" style="text-align: left">{{scope.row.receiveBackName}}</el-col>
              </el-row>
              <el-row :gutter="5">
                <el-col :span="8">姓名：</el-col>
                <el-col :span="16" style="text-align: left">{{scope.row.receiveUserName}}</el-col>
              </el-row>
              <el-row :gutter="5">
                <el-col :span="8">账号：</el-col>
                <el-col :span="16" style="text-align: left">{{scope.row.receiveMoneyBack}}</el-col>
              </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="transferBackInfos" label="充值信息" width="250">
          <template slot-scope="scope">
            <el-row :gutter="5">
              <el-col :span="8">银行：</el-col>
              <el-col :span="16" style="text-align: left">{{scope.row.transferBack}}</el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="8">姓名：</el-col>
              <el-col :span="16" style="text-align: left">{{scope.row.transferUserBack}}</el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="8">账号：</el-col>
              <el-col :span="16" style="text-align: left">{{scope.row.transferBackNumber}}</el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="审核时间"  width="98">
          <template slot-scope="scope">
            <span v-if="scope.row.statusStr=='审核通过'">{{scope.row.updateTime}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusStr" label="状态">
        </el-table-column>
        <el-table-column prop="moneyChangeTypeStr" label="类型" />
        <el-table-column prop="operPerson" label="操作人" >
          <template slot-scope="scope">
            <span v-if="scope.row.statusStr=='审核通过'">{{scope.row.operPerson}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注" />
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="success"
                       @click="handleEdit(scope.$index, scope.row,'充值审核', true)" v-show="scope.row.statusStr != '审核通过'">
              审核
            </el-button>
            <el-button size="mini" type="success"
                       @click="handleEdit(scope.$index, scope.row, '充值详情', false)">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle"
               :visible.sync="dialogFormVisible"
               style="text-align: left">
      <el-form ref="dialogForm" :model="dialogForm" >
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="充值时间:" label-width="30%">
              <div>{{dialogForm.dateTime}}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="充值编号:" label-width="30%">
              <div>{{dialogForm.invesMoneyNumber}}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="用户账号:" label-width="30%">
              <div>{{dialogForm.b2cUsersId}}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="用户类型:" label-width="30%">
              <div>{{dialogForm.userType}}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="汇款银行:" label-width="30%">
              <div>{{dialogForm.transferBack}}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="汇款卡号:" label-width="30%">
              <div>{{dialogForm.transferBackNumber}}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="汇款人:" label-width="30%">
              <div>{{dialogForm.transferUserBack}}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="收款银行:" label-width="30%">
              <div>{{dialogForm.receiveBackName}}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="收款卡号:" label-width="30%">
              <div>{{dialogForm.receiveMoneyBack}}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="收款人:" label-width="30%">
              <div>{{dialogForm.receiveUserName}}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="充值金额:" label-width="30%">
              <div>{{dialogForm.money}}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="充值截图:" label-width="30%">
              <div class="demo-image__preview">
              <el-image
                  :src="dialogForm.transferMoneyImageUrl"
                  :preview-src-list="new Array(dialogForm.transferMoneyImageUrl)">
              </el-image>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="审核状态:" label-width="30%">
              <div>{{dialogForm.statusStr}}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-show="isShow">
          <el-col :span="20">
            <el-form-item label="审核操作:" label-width="30%">
              <el-select v-model="dialogForm.status" clearable placeholder="审核状态" style="width: 80%">
                <el-option
                    v-for="item in statusOptions"
                    :key="item.id"
                    :label="item.value"
                    :value="item.flag"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-show="isShow">
          <el-col :span="20">
            <el-form-item label="备注:" label-width="30%">
              <el-input v-model="dialogForm.remarks" placeholder="审核备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm()" size="mini" type="primary" v-show="isShow">提交</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD';
import {
  getInvestMoneyRecords,
  updateInvestMoneyProcRecordsList,
  updateInvestMoneyRecords,
  updateInvestMoneyRecordsList
} from "../../api/b2cbusiness/b2c_investmoney";
import {getAllUserType} from "../../api/b2cbusiness/b2c_admin";
import qs from "qs";
import MinxinScroll from "@/components/MinxinScroll";

export default {
  name: "AccountInChangeMoneylist",
  mixins:[MixinCUD, MinxinScroll],
  data(){
    return {
      tableData:[],
      allUserType:[],
      reviewStatus:[
        {
          statusName:"未审核",
          status: 202111300001
        },
        {
          statusName:"审核中",
          status: 202206060001
        },
        {
          statusName:"审核未通过",
          status: 202111300002
        },
        {
          statusName:"审核通过",
          status: 202111300003
        }
      ],
      queryFormRefName:"queryForm",
      queryForm:{
        userName: '',
        userType: null,
        status: null,
        reviewUserName: '',
        timeRange:[],
      },
      multipleSelection:[],
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm:{
      },
      statusOptions: [
        {
          flag:"202111300003" ,
          value:"审核通过",
        },
        {
          flag: "202111300002" ,
          value:"审核未通过",
        },
        {
          flag: '202206060001',
          value:"审核中",
        },
        {
          flag: "202111300001" ,
          value:"未审核",
        }
      ],
      isShow: true,
      tableHeight: 650,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    getAllUserType().then(res=>{
      if (res.success){
        console.log(res.data)
        this.allUserType = res.data;
      }
    });
    let userTypeEnum = this.$route.query.userType;
    let statusTmp = this.$route.query.status;
    getInvestMoneyRecords({userType:userTypeEnum, status:statusTmp}, this.pagination).then(res=>{
      if (res.success){
        this.tableData = res.data.records;
        this.pagination.pageNum = res.data.current;
        this.pagination.pageSize = res.data.size;
        this.pagination.total = res.data.total;
      }
    });
  },
  methods: {
    exportInvistMoneyData(){
      window.open("https://api.weiquanai.com/accountchangerecords/exportinvstmoneydata?"+qs.stringify({
        userName: this.queryForm.userName,
        userType: this.queryForm.userType,
        status: this.queryForm.status,
        reviewUserName: this.queryForm.reviewUserName,
        startTime: this.queryForm.timeRange?this.queryForm.timeRange[0]:null,
        endTime: this.queryForm.timeRange?this.queryForm.timeRange[1]:null,
        pageNum: -1,
        pageSize: -1,
      }), "_blank");
    },
    handleReviewAdd(){
      console.log(this.multipleSelection)
      if (this.multipleSelection.length > 0){
        this.$confirm("是否批量审核选中的"+[this.multipleSelection.length]+"条充值记录？").then(_=>{
          updateInvestMoneyRecordsList(this.multipleSelection).then(res=>{
            if (res.success){
              this.$message({message: res.data, type: 'success'});
              this.submitQueryForm();//修改之后，重新查询table
              this.handleCloseDialog();
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }).catch(err => {this.handleCloseDialog();});
      }
    },
    handleReviewProBatch(){
      console.log(this.multipleSelection)
      if (this.multipleSelection.length > 0){
        this.$confirm("是否批量审核选中的"+[this.multipleSelection.length]+"条充值记录？").then(_=>{
          updateInvestMoneyProcRecordsList(this.multipleSelection).then(res=>{
            if (res.success){
              this.$message({message: res.data, type: 'success'});
              this.submitQueryForm();//修改之后，重新查询table
              this.handleCloseDialog();
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }).catch(err => {this.handleCloseDialog();});
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    submitDialogForm(){
      this.$refs[this.dialogRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                this.updateData();
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleCloseDialog();});
        } else {
          return false;
        }
      });
    },
    handleEdit(index, row,dialogTitle, isShow) {
      this.isShow = isShow;
      this.dialogFormVisible = true;
      this.dialogTitle = dialogTitle
      this.resetDialogForm()
      this.dialogForm = {...row}
    },
    getData(){
      /*
      if (this.queryForm.timeRange.length <= 0){
        this.queryForm.timeRange = this.tmpRange;
        console.log(this.queryForm, this.tmpRange)
      }

       */
      getInvestMoneyRecords(this.queryForm, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });
    },
    updateData(){
      updateInvestMoneyRecords(this.dialogForm).then(res=>{
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          this.submitQueryForm();//修改之后，重新查询table
          this.handleCloseDialog();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 10px;
}

.el-form-item{
  margin-bottom: 10px;
}
</style>
